<template>
  <div id="app" class="min-h-screen bg-gray-950">
    <nav
      v-if="isAuthenticated"
      class="bg-gray-900/80 backdrop-blur-sm border-b border-gray-800 sticky top-0 z-40"
    >
      <NavBar />
    </nav>
    <main class="min-h-screen">
      <router-view />
    </main>
    <NotificationContainer />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from './stores/auth';
import NavBar from './components/NavBar.vue';
import NotificationContainer from './components/NotificationContainer.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    NotificationContainer,
  },
  setup() {
    const authStore = useAuthStore();

    // Загружаем данные пользователя если есть токен
    if (authStore.token && !authStore.user) {
      authStore.fetchUser().catch(() => {
        // Если не удалось загрузить пользователя, очищаем токен
        authStore.logout();
      });
    }

    // Делаем isAuthenticated реактивным
    const isAuthenticated = computed(() => authStore.isAuthenticated);

    return {
      isAuthenticated,
    };
  },
};
</script>
